import { render, staticRenderFns } from "./v20a7000m.vue?vue&type=template&id=0cf5c2a1&"
import script from "./v20a7000m.vue?vue&type=script&lang=js&"
export * from "./v20a7000m.vue?vue&type=script&lang=js&"
import style0 from "./v20a7000m.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports